import React from 'react'
import shareIcon from "../../assets/svg/share-icon.svg";

type ShareButtonProps = {
  onClick?: () => void;
};
const ShareButton: React.FC<ShareButtonProps> = ({ onClick }) => {
  return (
     <button
      type="button"
      onClick={onClick}
      className=" w-[40px] h-[40px] flex justify-center items-center !z-[9999] cursor-pointer rounded-full outline-none bg-[#1E1E1E]"
    >
      <img width={16} height={16} alt="share button" src={shareIcon} />
    </button>
  )
}

export default ShareButton
